"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _DevelopmentInfoScript = require("./DevelopmentInfoScript");
Object.keys(_DevelopmentInfoScript).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DevelopmentInfoScript[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _DevelopmentInfoScript[key];
    }
  });
});
var _LazyOnScroll = require("./LazyOnScroll");
Object.keys(_LazyOnScroll).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _LazyOnScroll[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _LazyOnScroll[key];
    }
  });
});
